/**
 * Point d'entrée.
 *
 * Ordre des providers : Query au-dessus d'Auth, parce qu'une déconnexion doit
 * pouvoir vider le cache des requêtes ; Router en dessous des deux.
 */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { AuthProvider } from './hooks/useAuth';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Les donnees ne bougent qu'une fois par nuit : refaire une requete parce
      // que l'onglet reprend le focus ne rapporterait jamais rien de neuf.
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root introuvable dans index.html');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
